// import { useEffect, useState } from "react";
// import { useParams, Link } from "react-router-dom";
// import "./blog.css";

// const BlogPreview = () => {
//   const { slug } = useParams();
//   const [blog, setBlog] = useState(null);

//   useEffect(() => {
//     fetch(`http://localhost:5000/api/blog/slug/${slug}`)
//       .then((res) => res.json())
//       .then((data) => setBlog(data))
//       .catch((err) => console.error("Error fetching blog:", err));
//   }, [slug]);

//   if (!blog) return <p className="loading">Loading...</p>;

//   return (
//     <div className="blog-preview-container">
//       <div className="blog-preview-header">
//         <h1>{blog.title}</h1>
//         <p className="blog-meta">
//           By {blog.author} • {new Date(blog.createdAt).toDateString()}
//         </p>
//       </div>
//       <img
//         src={blog.thumbnail?.url}
//         alt={blog.title}
//         className="blog-preview-image"
//       />
//       <div
//         className="blog-preview-content"
//         dangerouslySetInnerHTML={{ __html: blog.contentHtml }}
//       />
//       <div className="blog-preview-tags">
//         {blog.tags.map((tag, i) => (
//           <span key={i} className="blog-tag">
//             #{tag}
//           </span>
//         ))}
//       </div>
//       <Link to="/blogs" className="back-link">
//         ← Back to Blogs
//       </Link>
//     </div>
//   );
// };

// export default BlogPreview;





// import { useEffect, useState } from "react";
// import { useParams, Link } from "react-router-dom";
// import "./blog.css";

// const BlogPreview = () => {
//   const { slug } = useParams();
//   const [blog, setBlog] = useState(null);
//   const [relatedBlogs, setRelatedBlogs] = useState([]);

//   // Date formatter
//   const formatDate = (dateStr) => {
//     const options = { day: "numeric", month: "long", year: "numeric" };
//     return new Date(dateStr).toLocaleDateString("en-GB", options);
//   };

//   useEffect(() => {
//     fetch(`http://localhost:5000/api/blog/slug/${slug}`)
//       .then((res) => res.json())
//       .then((data) => {
//         setBlog(data);

//         // Fetch all blogs to find related
//         fetch("http://localhost:5000/api/blog/bloglist")
//           .then((res) => res.json())
//           .then((list) => {
//             const related = list.blogs.filter(
//               (b) =>
//                 b._id !== data._id &&
//                 b.status === "published" &&
//                 b.tags.some((tag) => data.tags.includes(tag))
//             );
//             setRelatedBlogs(related.slice(0, 3)); // max 3 related
//           });
//       })
//       .catch((err) => console.error("Error fetching blog:", err));
//   }, [slug]);

//   if (!blog) return <p className="loading">Loading...</p>;

//   // Share links
//   const currentUrl = window.location.href;
//   const shareLinks = {
//     whatsapp: `https://wa.me/?text=${encodeURIComponent(
//       blog.title + " - " + currentUrl
//     )}`,
//     facebook: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
//     twitter: `https://twitter.com/intent/tweet?url=${currentUrl}&text=${blog.title}`,
//     linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`,
//     instagram: `https://www.instagram.com/?url=${currentUrl}`,
//     threads: `https://www.threads.net/intent/post?url=${currentUrl}&text=${blog.title}`,
//   };

//   return (
//     <div className="blog-preview-container">
//       {/* Title */}
//       <h1 className="blog-preview-title">{blog.title}</h1>

//       {/* Thumbnail */}
//       <img
//         src={blog.thumbnail?.url}
//         alt={blog.title}
//         className="blog-preview-image"
//       />

//       {/* Author & Date */}
//       <p className="blog-meta">
//         By {blog.author} • {formatDate(blog.createdAt)}
//       </p>

//       {/* Tags */}
//       <div className="blog-preview-tags">
//         {blog.tags.map((tag, i) => (
//           <span key={i} className="blog-tag">
//             #{tag}
//           </span>
//         ))}
//       </div>

//       {/* Content */}
//       <div
//         className="blog-preview-content"
//         dangerouslySetInnerHTML={{ __html: blog.contentHtml }}
//       />

//       {/* Share Section */}
//       <div className="share-section">
//         <h3>Share this article:</h3>
//         <div className="share-icons">
//           <a href={shareLinks.whatsapp} target="_blank" rel="noreferrer">
//             <i className="fab fa-whatsapp"></i>
//           </a>
//           <a href={shareLinks.facebook} target="_blank" rel="noreferrer">
//             <i className="fab fa-facebook"></i>
//           </a>
//           <a href={shareLinks.instagram} target="_blank" rel="noreferrer">
//             <i className="fab fa-instagram"></i>
//           </a>
//           <a href={shareLinks.twitter} target="_blank" rel="noreferrer">
//             <i className="fab fa-x-twitter"></i>
//           </a>
//           <a href={shareLinks.linkedin} target="_blank" rel="noreferrer">
//             <i className="fab fa-linkedin"></i>
//           </a>
//           <a href={shareLinks.threads} target="_blank" rel="noreferrer">
//             <i className="fa-brands fa-threads"></i>
//           </a>
//         </div>
//       </div>

//       {/* Related Blogs */}
//       {relatedBlogs.length > 0 && (
//         <div className="related-blogs">
//           <h2>More Blogs You May Like</h2>
//           <div className="blog-grid">
//             {relatedBlogs.map((b) => (
//               <Link key={b._id} to={`/blogs/${b.slug}`} className="blog-card">
//                 <img
//                   src={b.thumbnail?.url}
//                   alt={b.title}
//                   className="blog-thumbnail"
//                 />
//                 <div className="blog-content">
//                   <span className="blog-tag">{b.tags[0]}</span>
//                   <h3 className="blog-title">{b.title}</h3>
//                   <p className="blog-meta">
//                     {b.author} • {formatDate(b.createdAt)}
//                   </p>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </div>
//       )}

//       <Link to="/blogs" className="back-link">
//         ← Back to Blogs
//       </Link>
//     </div>
//   );
// };

// export default BlogPreview;







// ----------------------------------

import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./blogPreview.css";

const BlogPreview = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Date formatter
  const formatDate = (dateStr) => {
    const options = { day: "numeric", month: "long", year: "numeric" };
    return new Date(dateStr).toLocaleDateString("en-GB", options);
  };

  // Reading time calculator
  const getReadingTime = (content) => {
    const wordsPerMinute = 200;
    const words = content.replace(/<[^>]*>/g, '').split(' ').length;
    return Math.ceil(words / wordsPerMinute);
  };

  // Share functions
  const shareOnWhatsApp = () => {
    const text = `Check out this blog: ${blog.title}`;
    const url = window.location.href;
    window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
  };

  const shareOnFacebook = () => {
    const url = window.location.href;
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
  };

  const shareOnTwitter = () => {
    const text = `Check out this blog: ${blog.title}`;
    const url = window.location.href;
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank');
  };

  const shareOnLinkedIn = () => {
    const url = window.location.href;
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
  };

  const shareOnInstagram = () => {
    // Instagram doesn't support direct URL sharing, so copy to clipboard
    navigator.clipboard.writeText(window.location.href);
    alert('Link copied! You can paste it in your Instagram story or bio.');
  };

  const shareOnThreads = () => {
    const text = `Check out this blog: ${blog.title}`;
    const url = window.location.href;
    window.open(`https://threads.net/intent/post?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
  };

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
    setLoading(true);
    fetch(`${API_URL}/blog/slug/${slug}`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch blog');
        return res.json();
      })
      .then((data) => {
        setBlog(data);

        // Fetch all blogs to find related
        fetch(`${API_URL}/blog/bloglist`)
          .then((res) => res.json())
          .then((list) => {
            const related = list.blogs.filter(
              (b) =>
                b._id !== data._id &&
                b.status === "published" &&
                b.tags.some((tag) => data.tags.includes(tag))
            );
            setRelatedBlogs(related.slice(0, 3)); // max 3 related
          });
      })
      .catch((err) => {
        console.error("Error fetching blog:", err);
        setError(err.message);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading blog...</p>
    </div>
  );

  if (error) return (
    <div className="error-container">
      <h2>Something went wrong</h2>
      <p>{error}</p>
      <button onClick={() => window.location.reload()} className="retry-btn">
        Try Again
      </button>
    </div>
  );

  if (!blog) return null;

  return (
    <div className="blog-container">
      <div className="blog-content-wrapper">
        {/* Title */}
        <h1 className="blog-title">{blog.title}</h1>

        {/* Thumbnail */}
        <div className="blog-thumbnail-container">
          <img 
            src={blog.thumbnail?.url} 
            alt={blog.title}
            className="blog-thumbnail"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="thumbnail-placeholder" style={{display: 'none'}}>
            <i className="fas fa-image"></i>
            <span>Image not available</span>
          </div>
        </div>

        {/* Author and Date */}
        <div className="blog-meta">
          <div className="author-info">
            <i className="fas fa-user"></i>
            <span>By {blog.author}</span>
          </div>
          <div className="date-info">
            <i className="fas fa-calendar"></i>
            <span>{formatDate(blog.createdAt)}</span>
          </div>
          <div className="reading-time">
            <i className="fas fa-clock"></i>
            <span>{getReadingTime(blog.contentHtml)} min read</span>
          </div>
        </div>

        {/* Tags */}
        <div className="blog-tags">
          {blog.tags.map((tag, index) => (
            <span key={index} className="tag">
              #{tag}
            </span>
          ))}
        </div>

        {/* Rich Content */}
        <div 
          className="blog-rich-content"
          dangerouslySetInnerHTML={{ __html: blog.contentHtml }}
        />

        {/* Social Share */}
        <div className="social-share">
          <h3>Share this article</h3>
<div className="share-buttons">
  <button onClick={shareOnWhatsApp} className="share-btn whatsapp">
    <i className="fab fa-whatsapp"></i>
  </button>
  <button onClick={shareOnFacebook} className="share-btn facebook">
    <i className="fab fa-facebook-f"></i>
  </button>
  <button onClick={shareOnTwitter} className="share-btn twitter">
    <i className="fab fa-x-twitter"></i>
  </button>
  <button onClick={shareOnLinkedIn} className="share-btn linkedin">
    <i className="fab fa-linkedin-in"></i>
  </button>
  <button onClick={shareOnInstagram} className="share-btn instagram">
    <i className="fab fa-instagram"></i>
  </button>
  <button onClick={shareOnThreads} className="share-btn threads">
    <i className="fa-brands fa-threads"></i>
  </button>
</div>


        </div>

        {/* Related Blogs */}
        {relatedBlogs.length > 0 && (
          <div className="related-blogs">
            <h3>More blogs you may like</h3>
            <div className="related-blogs-grid">
              {relatedBlogs.map((b) => (
                <Link key={b._id} to={`/blogs/${b.slug}`} className="related-blog-card">
                  <div className="related-blog-image">
                    <img src={b.thumbnail?.url} alt={b.title} />
                    <span className="related-blog-tag">#{b.tags[0]}</span>
                  </div>
                  <div className="related-blog-content">
                    <h4>{b.title}</h4>
                    <p className="related-blog-meta">
                      {b.author} • {formatDate(b.createdAt)}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* Back to Blogs */}
        <div className="back-to-blogs">
          <Link to="/blogs" className="back-btn">
            <i className="fas fa-arrow-left"></i>
            Back to Blogs
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogPreview;




















